import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  OnDestroy,
} from "@angular/core";
import { OAuthService } from "angular-oauth2-oidc";
import { IUserProfile } from "app/bundles/authorize/shared/user-profile";
import { UserProfileService } from "app/bundles/authorize/shared/user-profile.service";
import { CurrentUserService } from "app/bundles/requests/shared/services/current-user.service";
import { RequestService } from "app/bundles/requests/shared/services/request.service";
import {
  concat,
  concatMap,
  forkJoin,
  map,
  merge,
  mergeMap,
  Subscription,
  switchMap,
  tap,
  zip,
} from "rxjs";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
})
export class HeaderComponent implements OnDestroy {
  public enableModal = false;
  private _modal = null;
  private subscriptions = new Subscription();
  public userProfile: IUserProfile;

  constructor(
    private securityService: OAuthService,
    private userProfileService: UserProfileService,
    private requestService: RequestService,
    private currentUserService: CurrentUserService,
    private changeDetectRef: ChangeDetectorRef,
  ) {
    this.subscriptions.add(this.fetchUserProfile().subscribe());
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  bindModal(modal) {
    this._modal = modal;
  }

  openPreference(): void {
    /*  this.document.getElementById("user-preference").style.width = "250px";
    //this.document.body.style.backgroundColor = "rgba(0,0,0,0.4)";
    this.document.getElementById("app-comp-id").style.backgroundColor = "rgba(0,0,0,0.4)";
    this.document.getElementById("app-comp-id").style.opacity = 0.5;
    */
  }

  login() {
    const islogin: boolean = this.securityService.hasValidAccessToken();
    if (islogin && islogin === true) {
      this.enableModal = true;
      this._modal.open();
    } else {
      this.securityService.initLoginFlow();
    }
  }

  close() {
    this._modal.close();
  }

  onEnableModal(event) {
    this.enableModal = event;
  }

  fetchUserProfile() {
    const trackUserProfile = this.userProfileService
      .getUserProfileFromEvents()
      .pipe(
        tap((user: IUserProfile) => {
          this.userProfile = user;
        }),
      );
    return trackUserProfile;
  }
}
